import axios from "axios"

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN': window.Laravel.csrfToken
};

export default {
  namespaced: true,
  state: () => ({
    notification: false,
    loading: false,
    open: false,
    sessionData: window.Laravel.sessionData,
    // Example of initial state of this object
    // {
    //   order_id: 0,
    //   items: [],
    //   total: {
    //     items: 0
    //   },
    //   details: [],
    //   shipping_method: 0
    // }
  }),
  getters: {
  },
  actions: {
    getCart: (context, data) => {
      // data is empty no needed
      var _url = '/' + window.Laravel.code + '/cart?timestamp=' + Math.random();
      return axios.get(_url)
        .then(function (response) {
          var sessionData = response.data;
          context.commit('GET_SESSION_DATA', sessionData);
        })
        .catch(function (error) {
          console.log('error:', error)
        });
    },
    addToCart: (context, data) => {

      console.log('data:', data)
      
      var _url = '/' + window.Laravel.code + '/cart/add';
      return axios.post(_url, data)
        .then(function (response) {
          context.dispatch('getCart');
        })
        .catch(function (error) {
          console.log('error:', error)
        });
    },
    increaseProductQuantity: (context, data) => {
      console.log('increase: ', data);
      if (!data.quantity || data.quantity <= 0) {
        data.quantity = 1;
      }
      context.state.cartLoading = true;
      var _uri = '/' + window.Laravel.code + '/cart/increase/' + data.id + '/' + data.quantity;
      axios.get(_uri).then(function (response) {
          var sessionData = response.data;
          context.commit('GET_SESSION_DATA', sessionData);
        })
        .catch(function (error) {
          console.log('error:', error);
        });
    },
    decreaseProductQuantity: (context, data) => {
      console.log('decrease: ', data);
      if (!data.quantity || data.quantity <= 0) {
        data.quantity = 1;
      }
      context.state.cartLoading = true;
      var _uri = '/' + window.Laravel.code + '/cart/decrease/' + data.id + '/' + data.quantity;
      axios.get(_uri).then(function (response) {
          var sessionData = response.data;
          context.commit('GET_SESSION_DATA', sessionData);
        })
        .catch(function (error) {
          console.log('error:', error);
        });
    },
    removeProduct: (context, data) => {
      context.state.cartLoading = true;
    },
    incart: (context, data) => {
      var activeVariant = data;
      var qtyfound = 0;
      try {
        context.state.sessionData.items.forEach(item => {
          if(item.variant_id == activeVariant.variant_id){
            qtyfound = item.qty;
          }
        });
      } catch (error) {
        
      }
      return qtyfound;
    }
  },
  mutations: {
    GET_SESSION_DATA: (state, data) => {
      state.sessionData = data;
    },
  }
}